import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Tooltip,
    Legend,
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Tooltip, Legend);

function Linechart({ influencer_trending }) {
    const { t } = useTranslation();
    const [lineChartData, setLineChartData] = useState(null);
    const [lineChartOptions, setLineChartOptions] = useState(null);

    useEffect(() => {
        if (!influencer_trending) return;

        const iData = influencer_trending.filter((d) => d.legend === "Influencers");
        const iIncrData = influencer_trending.filter((d) => d.legend === "Influencers Increment");
        const labels = iData.map((d) => d.axis_x);

        setLineChartData({
            labels,
            datasets: [
                {
                    type: "line",
                    label: "Influencers",
                    data: iData.map((d) => d.axis_y),
                    borderColor: "#E04ACB",
                    backgroundColor: "#E04ACB",
                    fill: true,
                    tension: 0.3,
                    yAxisID: "y",
                    pointRadius: 0,
                    pointHoverRadius: 4,
                },
                {
                    label: "Influencers Increment",
                    data: iIncrData.map((d) => d.axis_y),
                    backgroundColor: "#4F70FD",
                    type: "bar",
                    yAxisID: "y2",
                },
            ],
        });

        setLineChartOptions({
            responsive: true,
            interaction: {
                mode: "index",
                intersect: false,
            },
            stacked: false,
            plugins: {
                legend: {
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        pointStyle: "circle",
                        boxWidth: 10,
                        boxHeight: 10,
                    },
                },
                tooltip: { enabled: true },
                datalabels: { display: false },
                title: {
                    display: true,
                    text: t("Sales and GMV"),
                },
            },
            scales: {
                y: {
                    type: "linear",
                    position: "left",
                    title: {
                        display: true,
                        text: "Influencers",
                    },
                    grid: {
                        drawOnChartArea: true,
                    },
                },
                y2: {
                    type: "linear",
                    position: "right",
                    title: {
                        display: true,
                        text: "Influencers Increment",
                    },
                    grid: {
                        drawOnChartArea: false,
                    },
                },
                x: {
                    ticks: {
                        maxRotation: 45,
                        minRotation: 45,
                    },
                },
            },
        });
    }, [influencer_trending, t]);

    return (
        <Fragment>
            {lineChartData && lineChartOptions && <Chart type="bar" data={lineChartData} options={lineChartOptions} />}
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Linechart);
